var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bpc-order-table',{attrs:{"title":_vm.$t('global.profile.order.title'),"subtitle":'',"filterConfigName":'own',"formConfigName":'my-contact',"displayConfigName":'my-order',"withExtendedFilters":false}})}
var staticRenderFns = []

export { render, staticRenderFns }